/* eslint-disable import/prefer-default-export */
export function SendForm() {
  $(document).ready(() => {
    const input = document.getElementById('message-body');

    input.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById('submit-message').click();
      }
    });
  });
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/textarea_send.js